/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const volume_on = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14.316 10.504a4.44 4.44 0 0 0 0-4.736m-1.935 3.863a2.352 2.352 0 0 0 0-2.938M9.452 3.105a1.017 1.017 0 0 0-1.048.095L4.002 6.002H2a1.01 1.01 0 0 0-1.001 1v2.001c0 .545.456 1 1 1h2.002l4.402 2.802c.297.223.715.261 1.048.095.332-.166.553-.523.553-.895V4.001c0-.372-.22-.73-.553-.896Z"
    />
  </svg>
)
export default volume_on
